import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import QRCode from 'qrcode';

const Shortcuts = () => {

  const [safari, setSafri] = useState();
  const [chrome, setChrome] = useState();

  QRCode.toDataURL(`https://www.icloud.com/shortcuts/30e3ed7fcbe3438682aee64fde63dc90`)
  .then((url) => {
    setSafri(url);
  })
  .catch((err) => {
    console.error(err);
  });
  
  QRCode.toDataURL(`https://www.icloud.com/shortcuts/2e3efdf6e17e42c2a5e48a54b127cce4`)
  .then((url) => {
    setChrome(url);
  })
  .catch((err) => {
    console.error(err);
  });

// class Shortcuts extends Component {
  
  // constructor(props) {
  //   super(props);
  //   this.state = {};
  // }

  return(
      <div className="center">
        <h1>iOS Shortcuts Instructions</h1>
        {
          !isMobile && (
            <div style={{display: "flex"}}>
              <div>
                <h2>Safari Browser</h2>
                <img
                  src={safari}
                  alt="Safari QR code"
                  width="250"
                  height="auto"
                  style={{ margin: "0 30px 30px 30px" }}
                ></img>

              </div>
              <div>
                <h2>Chrome Browser</h2>
                <img
                  src={chrome}
                  alt="Chrome QR Code"
                  width="250"
                  height="auto"
                  style={{ margin: "0 30px 30px 30px" }}
                ></img>

              </div>

            </div>
          )
        }
        <div></div>
        <div>
          {'1. Add the Shortcuts for '}
          <a
            href="https://www.icloud.com/shortcuts/30e3ed7fcbe3438682aee64fde63dc90"
            target="_blank"
          >
            Safari
          </a>{' '}
          {' or '}
          <a
              href="https://www.icloud.com/shortcuts/2e3efdf6e17e42c2a5e48a54b127cce4"
              target="_blank"
            >
              Chrome
            </a>{' '}
          
        </div>
        <div>2. Tap the Share button in a browser</div>
        <div>3. Tap "Send to Audioread"</div>

      </div>
  );
}

export default Shortcuts;
